<h1>{{gamenData.title}}</h1>
<mat-card class="cur-card">
    <mat-card-content>{{gamenData.message}}</mat-card-content>
    <mat-progress-bar mode="indeterminate" class="progress"></mat-progress-bar>
    <div *ngFor="let koumoku of gamenData.koumokuList" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
            <mat-label>{{koumoku.label}}</mat-label>
            <input matInput [disabled]="true" value="{{koumoku.val}}" class="font-color-display-only">
        </mat-form-field>
    </div>


    <div fxLayout="row wrap" fxLayoutAlign="center center" class="div-button-ok">
        <div *ngIf="closeButtonFlg">
            <button class="btn" color="primary" mat-raised-button cdkFocusInitial (click)="onClickOk()">閉じる</button>
        </div>

        <div *ngIf="!closeButtonFlg">
            <button class="btn" color="primary" mat-raised-button cdkFocusInitial (click)="onClickOk()">OK</button>
        </div>
    </div>
</mat-card>